import {
  HStack,
  PinInput as ChakraPinInput,
  PinInputField,
} from "@chakra-ui/react";

// interface PinInputProps extends ChakraPinInputProps {}

const PinInput = (props) => {
  const { limit, size, otp, type, mask } = props;
  return (
    <HStack justifyContent="space-evenly">
      <ChakraPinInput
        otp={otp}
        type={type}
        size={size ?? "lg"}
        placeholder=""
        {...props}
        autoFocus={true}
        mask={mask ?? true}
      >
        {/* <PinInputField
          bg="#EFF0F6"
          _focus={{
            boxShadow: "0 0 0 3px #14e4648f",
            borderColor: "#14e4648f",
          }}
          borderRadius="14px"
        />
        <PinInputField
          bg="#EFF0F6"
          _focus={{
            boxShadow: "0 0 0 3px #14e4648f",
            borderColor: "#14e4648f",
          }}
          borderRadius="14px"
        />
        <PinInputField
          bg="#EFF0F6"
          _focus={{
            boxShadow: "0 0 0 3px #14e4648f",
            borderColor: "#14e4648f",
          }}
          borderRadius="14px"
        />
        <PinInputField
          bg="#EFF0F6"
          _focus={{
            boxShadow: "0 0 0 3px #14e4648f",
            borderColor: "#14e4648f",
          }}
          borderRadius="14px"
        />
        <PinInputField
          bg="#EFF0F6"
          _focus={{
            boxShadow: "0 0 0 3px #14e4648f",
            borderColor: "#14e4648f",
          }}
          borderRadius="14px"
        /> */}

        {Array(limit ?? 5)
          .fill(0)
          .map((_, i) => (
            <PinInputField
              key={`pin-input-${i}`}
              bg="#EFF0F6"
              _focus={{
                boxShadow: "0 0 0 3px #14e4648f",
                borderColor: "#14e4648f",
              }}
              borderRadius="14px"
            />
          ))}
      </ChakraPinInput>
    </HStack>
  );
};

export default PinInput;
